// frontend/src/views/EntryPoint.jsx

import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import AccessForm from '../components/AccessForm'
import { getStoredSession } from '../hooks/useHashSession'
import { useTranslation } from '../i18n'

export default function EntryPoint() {
  const [session, setSession] = useState(null);
  const [prefilledHash, setPrefilledHash] = useState(null);
  const [prefilledIdentifier, setPrefilledIdentifier] = useState(null);
  const navigate = useNavigate();
  const { _ } = useTranslation();

  useEffect(() => {
    const saved = getStoredSession();
    setSession(saved);

    // 🔹 leer hash precargado desde enlace de correo
    const incomingHash = sessionStorage.getItem('incoming_hash');
    if (incomingHash) {
      setPrefilledHash(incomingHash);
      sessionStorage.removeItem('incoming_hash');
    }

    const incomingIdentifier = sessionStorage.getItem('incoming_identifier');
    if (incomingIdentifier) {
      setPrefilledIdentifier(incomingIdentifier);
      sessionStorage.removeItem('incoming_identifier');
    }
  }, []);

  useEffect(() => {
    if (session?.hash) {
      if (session.role === 'leader') {
        navigate('/invitations');
      } else {
        navigate('/members');
      }
    }
  }, [session, navigate]);

  return (
    <div className="entrypoint-container w-full max-w-[20rem] p-4
                    md:max-w-sm md:p-6 mx-auto">
      <h2 className="entrypoint-title font-bold mb-4">
        {_('Group Access')}
      </h2>
      <AccessForm 
        prefilledHash={prefilledHash}
        prefilledIdentifier={prefilledIdentifier}
        onAccess={() => setSession(getStoredSession())} 
      />
    </div>
  );
}
